export const HighlightedBetsTabs = [
  {
    id: 'myBets',
    name: 'My Bets'
  }, {
    id: 'allBets',
    name: 'All Bets'
  }, {
    id: 'highRoller',
    name: 'High Rollers'
  }
  // {
  //   id: 'raceLeaderBoard',
  //   name: 'Race Leaderboard'
  // },
]

export const NumberOfRecordList = [0, 10, 20, 30, 40]

// export const CARD_DECK_MAPPING = {
//   'Ace of spade': [1, 'spade', 'Ace of spade', 1],
//   '2 of spade': [2, 'spade', '2 of spade', 2],
//   '3 of spade': [3, 'spade', '3 of spade', 3],
//   '4 of spade': [4, 'spade', '4 of spade', 4],
//   '5 of spade': [5, 'spade', '5 of spade', 5],
//   '6 of spade': [6, 'spade', '6 of spade', 6],
//   '7 of spade': [7, 'spade', '7 of spade', 7],
//   '8 of spade': [8, 'spade', '8 of spade', 8],
//   '9 of spade': [9, 'spade', '9 of spade', 9],
//   '10 of spade': [10, 'spade', '10 of spade', 10],
//   'Jack of spade': [10, 'spade', 'Jack of spade', 11],
//   'Queen of spade': [10, 'spade', 'Queen of spade', 12],
//   'King of spade': [10, 'spade', 'King of spade', 13],
//   'Ace of club': [1, 'club', 'Ace of club', 14],
//   '2 of club': [2, 'club', '2 of club', 15],
//   '3 of club': [3, 'club', '3 of club', 16],
//   '4 of club': [4, 'club', '4 of club', 17],
//   '5 of club': [5, 'club', '5 of club', 18],
//   '6 of club': [6, 'club', '6 of club', 19],
//   '7 of club': [7, 'club', '7 of club', 20],
//   '8 of club': [8, 'club', '8 of club', 21],
//   '9 of club': [9, 'club', '9 of club', 22],
//   '10 of club': [10, 'club', '10 of club', 23],
//   'Jack of club': [10, 'club', 'Jack of club', 24],
//   'Queen of club': [10, 'club', 'Queen of club', 25],
//   'King of club': [10, 'club', 'King of club', 26],
//   'Ace of heart': [1, 'heart', 'Ace of heart', 27],
//   '2 of heart': [2, 'heart', '2 of heart', 28],
//   '3 of heart': [3, 'heart', '3 of heart', 29],
//   '4 of heart': [4, 'heart', '4 of heart', 30],
//   '5 of heart': [5, 'heart', '5 of heart', 31],
//   '6 of heart': [6, 'heart', '6 of heart', 32],
//   '7 of heart': [7, 'heart', '7 of heart', 33],
//   '8 of heart': [8, 'heart', '8 of heart', 34],
//   '9 of heart': [9, 'heart', '9 of heart', 35],
//   '10 of heart': [10, 'heart', '10 of heart', 36],
//   'Jack of heart': [10, 'heart', 'Jack of heart', 37],
//   'Queen of heart': [10, 'heart', 'Queen of heart', 38],
//   'King of heart': [10, 'heart', 'King of heart', 39],
//   'Ace of diamond': [1, 'diamond', 'Ace of diamond', 40],
//   '2 of diamond': [2, 'diamond', '2 of diamond', 41],
//   '3 of diamond': [3, 'diamond', '3 of diamond', 42],
//   '4 of diamond': [4, 'diamond', '4 of diamond', 43],
//   '5 of diamond': [5, 'diamond', '5 of diamond', 44],
//   '6 of diamond': [6, 'diamond', '6 of diamond', 45],
//   '7 of diamond': [7, 'diamond', '7 of diamond', 46],
//   '8 of diamond': [8, 'diamond', '8 of diamond', 47],
//   '9 of diamond': [9, 'diamond', '9 of diamond', 48],
//   '10 of diamond': [10, 'diamond', '10 of diamond', 49],
//   'Jack of diamond': [10, 'diamond', 'Jack of diamond', 50],
//   'Queen of diamond': [10, 'diamond', 'Queen of diamond', 51],
//   'King of diamond': [10, 'diamond', 'King of diamond', 52]
// }

export const CARD_DECK_MAPPING = {
  'Ace of spade': [1, 'spade', 'Ace of spade', 1],
  '2 of spade': [2, 'spade', '2 of spade', 2],
  '3 of spade': [3, 'spade', '3 of spade', 3],
  '4 of spade': [4, 'spade', '4 of spade', 4],
  '5 of spade': [5, 'spade', '5 of spade', 5],
  '6 of spade': [6, 'spade', '6 of spade', 6],
  '7 of spade': [7, 'spade', '7 of spade', 7],
  '8 of spade': [8, 'spade', '8 of spade', 8],
  '9 of spade': [9, 'spade', '9 of spade', 9],
  '10 of spade': [10, 'spade', '10 of spade', 10],
  'Jack of spade': [10, 'spade', 'Jack of spade', 11],
  'Queen of spade': [10, 'spade', 'Queen of spade', 12],
  'King of spade': [10, 'spade', 'King of spade', 13],
  'Ace of club': [1, 'club', 'Ace of club', 14],
  '2 of club': [2, 'club', '2 of club', 15],
  '3 of club': [3, 'club', '3 of club', 16],
  '4 of club': [4, 'club', '4 of club', 17],
  '5 of club': [5, 'club', '5 of club', 18],
  '6 of club': [6, 'club', '6 of club', 19],
  '7 of club': [7, 'club', '7 of club', 20],
  '8 of club': [8, 'club', '8 of club', 21],
  '9 of club': [9, 'club', '9 of club', 22],
  '10 of club': [10, 'club', '10 of club', 23],
  'Jack of club': [10, 'club', 'Jack of club', 24],
  'Queen of club': [10, 'club', 'Queen of club', 25],
  'King of club': [10, 'club', 'King of club', 26],
  'Ace of heart': [1, 'heart', 'Ace of heart', 27],
  '2 of heart': [2, 'heart', '2 of heart', 28],
  '3 of heart': [3, 'heart', '3 of heart', 29],
  '4 of heart': [4, 'heart', '4 of heart', 30],
  '5 of heart': [5, 'heart', '5 of heart', 31],
  '6 of heart': [6, 'heart', '6 of heart', 32],
  '7 of heart': [7, 'heart', '7 of heart', 33],
  '8 of heart': [8, 'heart', '8 of heart', 34],
  '9 of heart': [9, 'heart', '9 of heart', 35],
  '10 of heart': [10, 'heart', '10 of heart', 36],
  'Jack of heart': [10, 'heart', 'Jack of heart', 37],
  'Queen of heart': [10, 'heart', 'Queen of heart', 38],
  'King of heart': [10, 'heart', 'King of heart', 39],
  'Ace of diamond': [1, 'diamond', 'Ace of diamond', 40],
  '2 of diamond': [2, 'diamond', '2 of diamond', 41],
  '3 of diamond': [3, 'diamond', '3 of diamond', 42],
  '4 of diamond': [4, 'diamond', '4 of diamond', 43],
  '5 of diamond': [5, 'diamond', '5 of diamond', 44],
  '6 of diamond': [6, 'diamond', '6 of diamond', 45],
  '7 of diamond': [7, 'diamond', '7 of diamond', 46],
  '8 of diamond': [8, 'diamond', '8 of diamond', 47],
  '9 of diamond': [9, 'diamond', '9 of diamond', 48],
  '10 of diamond': [10, 'diamond', '10 of diamond', 49],
  'Jack of diamond': [10, 'diamond', 'Jack of diamond', 50],
  'Queen of diamond': [10, 'diamond', 'Queen of diamond', 51],
  'King of diamond': [10, 'diamond', 'King of diamond', 52]
}

export const RESULT_STATE = {
  WIN: 'win',
  LOSE: 'lose',
  UNSET: null
}
